import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {RewardModel} from "../reward/RewardModel";
import {GuardConfig} from "../guard/GuardConfig";
import {ProductModel} from "../product/ProductModel";

export class PackageModel extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._silent = false;
        this._guard = new GuardConfig();
        this._reward = null;
        this._products = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get silent() {
        return this._silent;
    }

    set silent(value) {
        this._silent = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    valid() {

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.products && this.products.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PackageModel());
        } else if (target instanceof PackageModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PackageModel, {
    _uid: alias("uid", Schema.primitive()),

    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _silent: alias("silent", Schema.primitive()),

    _guard: alias("guard", GuardConfig.schema()),
    _reward: alias("reward", RewardModel.schema()),
    _products: alias("products", list(ProductModel.schema()))
});